import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { UserService } from '@core/services/user/user.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserEmailExistsValidator implements AsyncValidator {
  constructor(private userService: UserService) { }

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    return this.userService.checkUserEmail(control.value).pipe(
      map(value => {
        return value ? { userEmailExists: true } : null
      }),
      catchError(() => of(null))
    );
  }
}

